export default "__VITE_ASSET__CgtJDIm1__"